export const chart_lang={
  TH:{
    type_search:"เลือกเอกสาร",
    choose_type_report:"เลือกประเภทเอกสาร/เดือนที่ต้องการ",
    month_search:"เลือกเดือน"
  },
  EN:{
    type_search:"search by document",
    choose_type_report:"choose type document",
    month_search:"choose month"
  }
}
